import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { z } from 'zod';
import { SurveyStandalonePage } from '@/features/surveys';

const SurveyTabSchema = z.enum(['overview', 'submit', 'questions', 'responses', 'settings']);

const SurveyDetailSearchSchema = z.object({
  tab: SurveyTabSchema.optional(),
});

export const Route = createFileRoute('/surveys_/$surveyId/')({
  component: SurveyDetailRoute,
  validateSearch: (search) => SurveyDetailSearchSchema.parse(search),
});

function SurveyDetailRoute(): ReactNode {
  const { surveyId } = Route.useParams();
  const search = Route.useSearch();
  return (
    <SurveyStandalonePage
      surveyId={surveyId}
      {...(search.tab !== undefined ? { tab: search.tab } : {})}
    />
  );
}
